import { css, CSSResult } from 'lit'
import { csColorAction } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const cscOrderFormButton = {
  confirmedBackgroundColor: css`var(--csc-order-form-button-confirmed-background-color, ${csColorAction.primary})`,
  confirmedBackgroundColorHover: css`var(--csc-order-form-button-confirmed-background-color-hover, ${csColorAction.primaryHover})`,
  confirmedIconColor: css`var(--csc-order-form-confirmed-button-icon-color, inherit)`,
}

export const style: CSSResult = css`
  :host([state="confirmed"]) cse-button {
    --cse-button-primary-background-color: ${cscOrderFormButton.confirmedBackgroundColor};
    --cse-button-primary-background-color-hover: ${cscOrderFormButton.confirmedBackgroundColorHover};
  }

  :host([state="confirmed"]) cse-icon {
    --cse-icon-color: ${cscOrderFormButton.confirmedIconColor};
  }
`
